/* ============================================================================
   gs-mats-data.js — grow-some
   Path: assets/gs-mats-data.js

   Single source of truth for the seed-pad ("килимки") catalog + Ukrainian
   plural helper, shared by:
     • assets/gs-addons-bundle.js  (product-page bundle coordinator)
     • assets/gs-quick-pads.js     (collection quick-add pad drawer)

   Load this BEFORE either consumer (both use `defer`, so source order is
   preserved). Consumers fall back to their own copy if this fails to load.
   ============================================================================ */
(function () {
  var CDN = 'https://cdn.shopify.com/s/files/1/0568/2688/8235/files/';

  window.GS_MATS = [
    { id: 'brokoli', name: 'Броколі',         img: CDN + 'grow-some-seedpad-broccoli.webp?v=1777217511' },
    { id: 'kapusta', name: 'Капуста червона', img: CDN + 'grow-some-seedpad-red-cabbage.webp?v=1777217511' },
    { id: 'morkva',  name: 'Морква',          img: CDN + 'grow-some-seedpad-carrot.webp?v=1777217511' },
    { id: 'shchek',  name: 'Щекавиця (мікс)', img: CDN + 'grow-some-seedpad-shekavysya.webp?v=1777218120' },
    { id: 'lyuts',   name: 'Люцерна',         img: CDN + 'grow-some-seedpad-alfalfa.webp?v=1777217510' },
    { id: 'sonyakh', name: 'Сонях',           img: CDN + 'grow-some-seedpad-sunflower.webp?v=1777217511' },
    { id: 'redys',   name: 'Редис',           img: CDN + 'grow-some-seedpad-radish.webp?v=1777217511' },
    { id: 'gorox',   name: 'Горох вусатий',   img: CDN + 'grow-some-seedpad-pea.webp?v=1777217511' },
    { id: 'girch',   name: 'Гірчиця',         img: CDN + 'grow-some-seedpad-mustard.webp?v=1777217511' },
    { id: 'kony',    name: 'Конюшина',        img: CDN + 'grow-some-seedpad-clover.webp?v=1777218120' },
    { id: 'koty',    name: 'Трава котикам',   img: CDN + 'grow-some-seedpad-catgrass.webp?v=1777217511' },
    { id: 'gorox2',  name: 'Горох дикий',     img: CDN + 'grow-some-seedpad-wild-pea.webp?v=1777217511' }
  ];

  // Ukrainian plural for "килимок": 1 → килимок, 2-4 → килимки, else → килимків
  // (11-19 → килимків).
  window.GS_decKyl = function (n) {
    var a = Math.abs(n) % 100, r = a % 10;
    if (a >= 11 && a <= 19) return 'килимків';
    if (r === 1) return 'килимок';
    if (r >= 2 && r <= 4) return 'килимки';
    return 'килимків';
  };
})();
